/* eslint-disable radix */

/* eslint-disable no-param-reassign */

/* eslint-disable prefer-const */

/* eslint-disable func-names */

/* eslint-disable import/prefer-default-export */

/* Resta el porcentaje indicado a un color (RR, GG o BB) hexadecimal para oscurecerlo */
var subtractLight = function subtractLight(color, amount) {
  var cc = parseInt(color, 16) - amount;
  var c = cc < 0 ? 0 : cc;
  c = c.toString(16).length > 1 ? c.toString(16) : "0".concat(c.toString(16));
  return c;
};
/* Oscurece un color hexadecimal de 6 caracteres #RRGGBB segun el porcentaje indicado */


export var darken = function darken(color, amount) {
  color = color.indexOf('#') >= 0 ? color.substring(1, color.length) : color;
  amount = parseInt(255 * amount / 100);
  var partOne = subtractLight(color.substring(0, 2), amount);
  var partTwo = subtractLight(color.substring(2, 4), amount);
  var partThree = subtractLight(color.substring(4, 6), amount);
  return "#".concat(partOne).concat(partTwo).concat(partThree);
};
/* Suma el porcentaje indicado a un color (RR, GG o BB) hexadecimal para aclararlo */

var addLight = function addLight(color, amount) {
  var cc = parseInt(color, 16) + amount;
  var c = cc > 255 ? 255 : cc;
  c = c.toString(16).length > 1 ? c.toString(16) : "0".concat(c.toString(16));
  return c;
};
/* Aclara un color hexadecimal de 6 caracteres #RRGGBB segun el porcentaje indicado */


export var lighten = function lighten(color, amount) {
  color = color.indexOf('#') >= 0 ? color.substring(1, color.length) : color;
  amount = parseInt(255 * amount / 100);
  var partOne = addLight(color.substring(0, 2), amount);
  var partTwo = addLight(color.substring(2, 4), amount);
  var partThree = addLight(color.substring(4, 6), amount);
  return "#".concat(partOne).concat(partTwo).concat(partThree);
};
var opacity = {
  100: 'FF',
  99: 'FC',
  98: 'FA',
  97: 'F7',
  96: 'F5',
  95: 'F2',
  94: 'F0',
  93: 'ED',
  92: 'EB',
  91: 'E8',
  90: 'E6',
  89: 'E3',
  88: 'E0',
  87: 'DE',
  86: 'DB',
  85: 'D9',
  84: 'D6',
  83: 'D4',
  82: 'D1',
  81: 'CF',
  80: 'CC',
  79: 'C9',
  78: 'C7',
  77: 'C4',
  76: 'C2',
  75: 'BF',
  74: 'BD',
  73: 'BA',
  72: 'B8',
  71: 'B5',
  70: 'B3',
  69: 'B0',
  68: 'AD',
  67: 'AB',
  66: 'A8',
  65: 'A6',
  64: 'A3',
  63: 'A1',
  62: '9E',
  61: '9C',
  60: '99',
  59: '96',
  58: '94',
  57: '91',
  56: '8F',
  55: '8C',
  54: '8A',
  53: '87',
  52: '85',
  51: '82',
  50: '80',
  49: '7D',
  48: '7A',
  47: '78',
  46: '75',
  45: '73',
  44: '70',
  43: '6E',
  42: '6B',
  41: '69',
  40: '66',
  39: '63',
  38: '61',
  37: '5E',
  36: '5C',
  35: '59',
  34: '57',
  33: '54',
  32: '52',
  31: '4F',
  30: '4D',
  29: '4A',
  28: '47',
  27: '45',
  26: '42',
  25: '40',
  24: '3D',
  23: '3B',
  22: '38',
  21: '36',
  20: '33',
  19: '30',
  18: '2E',
  17: '2B',
  16: '29',
  15: '26',
  14: '24',
  13: '21',
  12: '1F',
  11: '1C',
  10: '1A',
  9: '17',
  8: '14',
  7: '12',
  6: '0F',
  5: '0D',
  4: '0A',
  3: '08',
  2: '05',
  1: '03',
  0: '00'
};
export var applyAlpha = function applyAlpha(color, alpha) {
  return color + opacity[alpha];
};